export const outputFile = (
    portfolioId: string | undefined,
    fireId: string | undefined,
    flightId: string | undefined,
    filename: string,
    isDemo?: boolean
) => {
    return isDemo
        ? `flight/${flightId}/video/${filename}`
        : `public/org/${portfolioId}/fire/${fireId}/flight/${flightId}/video/${filename}`
}
